














import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import myform from '../../../components/form/index.vue'
import {CreateOrganization, DeleteOrganization, GetOraganizationList, UpdateOrganization} from "@/api/organization"
import myTree from './tree'
@Component({
    components:{myform, myTree}
})
export default class Organization extends AbpBase {
    formShow = false
    formTitle = ''
    formData:any = {}
    private async getChildren(item: any) {
        item.loading = true
        let res = await GetOraganizationList({id: item.id})
        if (res.length) {
            item.children.push(...res.map(item=>{
                item.label = item.organizationName;
                item.showing = false;
                item.children = []
                return item
            }))
        }
        item.showing = !item.showing
        item.loading = false
    }
    typeClick(item: any){
        if (item.children.length || item.showing) {
            item.showing = !item.showing
        } else {
            this.getChildren(item)
        }
    }
    tree = [
        {
            id: 0,
            label: '中民投集团',
            showing: true,
            loading: false,
            children: []
        }
    ]
    formItem = [
        {
            column:24,
            show:true,
            label:'名称',
            name:'organizationName',
            type:'text',
            placeholder:'请输入名称',
            rules:[
                { required: true, message: '不能为空', trigger: 'blur' },
            ],
        },
        {
            column:24,
            show:true,
            label:'备注',
            name:'remark',
            type:'textarea',

        },
        // {
        //     column:24,
        //     show:true,
        //     label:'是否激活',
        //     name:'status',
        //     type:'switch',
        // }
    ]
    private async getData() {
        let res = await GetOraganizationList({})
        if (res.length) {
            this.tree[0].children = []
            this.tree[0].children.push(...res.map(item => {
                item.label = item.organizationName;
                item.showing = false;
                item.children = []
                return item
            }))
        }

    }
    created() {
        this.getData()
    }
    add(data:any){
        this.formShow = true
        this.formTitle = '新增'
        this.formData = {
            parentId: data.id,
            status: true
        }
    }
    edit(data:any){
        this.formShow = true
        this.formTitle = '编辑'
        this.formData = {
            ...data,
        }
    }
    async remove(data:any){
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示',{
            confirmButtonText:this.L('Yes'),
            cancelButtonText:this.L('No')})
            .then(async () => {
                let res = await DeleteOrganization({id: data.id})
                this.getData()
            })
    }
    async submit(data:any){
        
        let res
        if (this.formTitle === '新增') {
            res = await CreateOrganization(data)
        } else {
            res = await UpdateOrganization(data)
        }
        if(res.code===2000){
            this.formShow = false
            this.getData()
        }
    }
}
